import SelectContact from "@/views/crud/modules/SelectContact";
import SelectWeekday from "@/views/crud/modules/SelectWeekday";

export default {
  key: "contact_group",
  id: "contact_group_id",
  export: [],
  excel: {
     //max_row: "50000" 
  },
  sort_fields: [
    "contact_group_id",
    "name",
    "email"
  ],
  filters: {
    contact_group_id: {},
    name: {},
    email: {},
  },
  fields: [
    { key: "contact_group_id", width: 75 },
    { key: "name" },
    { key: "status", type: "boolean", width: 70 },
    { key: "level", type:"componentColumn", component:SelectWeekday, option:[{id:1,name:1},{id:5,name:5},{id:10,name:10}], multiple:false },
    { key: "contactIds", type:"componentColumn", label:"email", value:"contact_id", get_option:"contact", get_data:"contact_and_contact_group", component:SelectContact, hidden: ["list"]},
    { key: "locIds", type:"componentColumn", label:"address", value:"loc_id", get_option:"cp_locs", get_data:"contact_group_and_cp_loc", component:SelectContact, hidden: ["list"]},
    { key: "errorIds", type:"componentColumn", label:"name_chi", value:"error_id", get_option:"alert_error_code", get_data:"contact_group_and_alert_error_code", component:SelectContact, hidden: ["list"]},
    { type: "action-btn", width: 110 }
  ],
  structure: [
    ["name"],
    ["status","level"],
    ["contactIds"],
    ["locIds"],
    ["errorIds"],
  ],
  action: ["create", "edit", "view", "delete"],
  view: [
    ["name"],
    ["status","level"],
    [{ key: "contactIds", type:"componentColumn", label:"email", value:"contact_id", get_option:"contact", get_data:"contact_and_contact_group", component:SelectContact}],
    [{ key: "locIds", type:"componentColumn", label:"address", value:"loc_id", get_option:"cp_locs", get_data:"contact_group_and_cp_loc", component:SelectContact}],
    [{ key: "errorIds", type:"componentColumn", label:"name_chi", value:"error_id", get_option:"alert_error_code", get_data:"contact_group_and_alert_error_code", component:SelectContact}],
  ],
  extra_components: {
  }
}